<template>
  <tr :class="computedClass" :style="computedStyle"
    @click="$emit('click', $event)">
    <slot></slot>
  </tr>
</template>

<script>
export default {
  props: ["header", "selected", "disabled", "background"],

  computed: {
    computedClass() {
      return this.selected ? "table-row selected" : "table-row";
    },
    computedStyle() {
      const background = this.background
        ? `background-color: ${this.background};`
        : "";

      return `${background} opacity: ${this.disabled ? "0.5" : "1"}`;
    },
  },
};
</script>

<style scoped>
.table-row {
  height: 38px;
  font-size: 0.75rem;
}

.table-row td {
  border-bottom: 1px solid var(--s-box-line-border-color);
}

.table-row:hover {
  background-color: var(--s-box-line-border-color) !important;
}

.selected {
  background-color: var(--s-box-line-border-color) !important;
}
</style>